module.exports = __webpack_public_path__ + "static/media/intro-parents.c72058fc.svg";